/**
 * The audit log — design/PROTOTYPE-SPEC.md §10: "Append-only record of all
 * actions, filterable by person/category/date range. Cannot edit or delete."
 *
 * The categories live here rather than in the API because the filter UI has to
 * render them. Two copies of this list is how a filter ends up offering a
 * category nothing writes, or missing one that everything does.
 */
import { z } from 'zod';
export const AUDIT_CATEGORIES = [
    'stock',
    'correction',
    'settings',
    'team',
    'billing',
    'auth',
    'data',
];
export const AUDIT_CATEGORY_LABEL = {
    stock: 'Stock',
    correction: 'Corrections',
    settings: 'Settings',
    team: 'Team',
    billing: 'Billing',
    auth: 'Sign-in',
    data: 'Import & export',
};
/** How many entries a page returns when the caller does not say. */
export const AUDIT_PAGE_SIZE = 50;
export const AUDIT_PAGE_MAX = 200;
const isoDate = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Dates must be YYYY-MM-DD');
/**
 * Query parameters arrive as strings, so everything is coerced here rather than
 * in the route. `cursor` is a `seq` value, not an offset: the log is append-only
 * and constantly growing, and OFFSET paging over a table that gains rows between
 * requests silently repeats and skips entries.
 */
export const auditQuerySchema = z
    .object({
    category: z.enum(AUDIT_CATEGORIES).optional(),
    userId: z.string().uuid('Not a valid person').optional(),
    /** Inclusive, in the account's own time zone — resolved by the route. */
    from: isoDate.optional(),
    to: isoDate.optional(),
    /** Entries strictly older than this `seq`. Opaque to the caller. */
    cursor: z.coerce.number().int().positive().optional(),
    limit: z.coerce.number().int().min(1).max(AUDIT_PAGE_MAX).default(AUDIT_PAGE_SIZE),
})
    .refine((q) => !q.from || !q.to || q.from <= q.to, {
    message: 'The start date must not be after the end date',
    path: ['from'],
});
//# sourceMappingURL=schemas.js.map